import React from 'react';
import { Section } from './ui/Section';
import { RefreshCw, ShieldCheck, Puzzle, Calendar } from 'lucide-react';
export function MechanismSection() {
  const steps = [{
    icon: RefreshCw,
    title: 'RESET (Semana 1)',
    desc: 'Cortas el ciclo sin provocar una guerra todos los días. Preparas el entorno, defines zonas y horarios ancla, y reduces los detonantes que hacen que tu hijo explote.'
  }, {
    icon: ShieldCheck,
    title: 'REGLAS (Semana 2)',
    desc: 'Instalas pocas reglas, claras, visibles y consistentes. Incluye guiones para responder sin entrar a discusiones interminables.'
  }, {
    icon: Puzzle,
    title: 'REEMPLAZO (Semana 3)',
    desc: "Lo que casi nadie hace: llenas el vacío. Porque si quitas pantalla y no pones nada, tu hijo no 'aprende disciplina'… aprende ansiedad y aburrimiento, y recae."
  }, {
    icon: Calendar,
    title: 'MANTENER (Semana 4)',
    desc: 'Vacaciones, visitas, fines de semana, enfermedad, estrés: el plan para que no se rompa en los momentos donde siempre se rompe.'
  }];
  return <Section background="navy" className="relative overflow-hidden" data-id="element-104">
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-32 -mt-32 blur-3xl" data-id="element-105"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#dc4a3d]/10 rounded-full -ml-48 -mb-48 blur-3xl" data-id="element-106"></div>

      <div className="relative z-10" data-id="element-107">
        <div className="text-center mb-8" data-id="element-108">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-109">
            El Sistema 3R
          </h2>
          <p className="text-blue-100 text-base max-w-2xl mx-auto" data-id="element-110">
            Pantallas Bajo Control usa un sistema simple para ganar donde la
            fuerza de voluntad pierde.
          </p>
        </div>

        <div className="grid gap-4" data-id="element-111">
          {steps.map((step, index) => <div key={index} className="bg-white/10 backdrop-blur-sm border border-white/10 p-4 md:p-5 rounded-xl flex flex-col md:flex-row gap-4 items-start" data-id="element-112">
              <div className="bg-[#dc4a3d] p-3 rounded-lg shrink-0" data-id="element-113">
                <step.icon className="w-6 h-6 text-white" data-id="element-114" />
              </div>
              <div data-id="element-115">
                <h3 className="text-lg font-bold text-white mb-1" data-id="element-116">
                  {step.title}
                </h3>
                <p className="text-blue-100 leading-relaxed text-sm" data-id="element-117">
                  {step.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}